<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-app dark id="inspire" style="background-image: linear-gradient( 135deg, #3C8CE7 10%, #00EAFF 100%);">

      <v-content>
        <v-container
          class="fill-height"
          fluid
        >
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="8"
              md="3"
            >
              <v-card class="elevation-12">
                <v-toolbar
                  color="blue darken-2"
                  dark
                  flat
                >
                  <v-toolbar-title>超管登录</v-toolbar-title>


                </v-toolbar>
                <v-card-text>
                  <v-form
                    ref="form"
                  >
                    <v-text-field
                      label="验证码"
                      name="login"
                      v-model="loginRequest.verifyCode"
                      :rules="[v => !!v || '必输的哦~']"
                      prepend-icon="code"
                      type="text"
                    >
                      <template v-slot:append-outer>
                        <v-img @click="refreshVerfyImg" :src="verifyData.verifyImg"></v-img>
                      </template>
                    </v-text-field>

                    <v-text-field
                      id="password"
                      label="通行证"
                      v-model="loginRequest.passWord"
                      :rules="[v => !!v || '必输的哦~']"
                      name="password"
                      prepend-icon="lock"
                      type="password"
                    />

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn @click="commit" dark color="blue darken-2">提交</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-content>

    <z-notify ref="notify"></z-notify>

  </v-app>
</template>

<script>
  import {imgVerify, adminLogin} from '@/api/login'
  import Verify from 'vue2-verify'

  export default {
    name: "AdminLogin",
    data() {
      return {
        verifyData: {
          verifyImg: '',
          verifyId: '',
          verifyCode: ''
        },
        loginRequest: {
          verifyId: '',
          verifyCode: '',
          passWord: ''
        },

      }
    },
    components:{
      Verify,
    },
    methods: {
      successEvent(){
        alert('验证成功');
      },
      commit() {
        if (this.$refs.form.validate()) {
          adminLogin(this.loginRequest).then(res => {
            if(res.verifyResult == '1'){
              this.$store.dispatch('logIn',res.token )
              this.$store.dispatch('acctLoadedOut' )
              this.$router.push({path: '/admin/user-management'})
            }else if(res.verifyResult == '-1'){
              this.$refs.notify.show("验证码",{timeout:1000})
              this.refreshVerfyImg()
            }else if(res.verifyResult == '0'){
              this.$refs.notify.show("验证码输入错误",{timeout:1000})
              this.refreshVerfyImg()
            }
          }).catch(err => console.error(err))
        }
      },
      refreshVerfyImg() {
        this.loginRequest.verifyCode = '';
        this.$store.dispatch('logOut');
        let req = {
          width: 100,
          height: 30
        };
        imgVerify(req).then(res => {
          this.verifyData.verifyImg = 'data:image/gif;base64,' + res.imgData;
          this.loginRequest.verifyId = res.verifyId;
          this.loginRequest.verifyCode = res.verifyCode;
        }).catch(err => console.error(err))
      }
    },
    created() {
      this.refreshVerfyImg();
      this.$vuetify.theme.dark = false;
    }
  }
</script>

<style scoped>

</style>

// https://blog.csdn.net/qq_37816525/article/details/102560895

// verify 参数说明
//
// ready	验证码初始化成功的回调函数。
// success验证码匹配成功后的回调函数。如要重新初始化：success:function(obj){obj.refresh();}。
// error	验证码匹配失败后的回调函数。
//
// 常规验证码picture
// 参数	说明
//
// type	验证码type为picture或者1
// width	常规验证码的宽,支持百分比形式设置，如：width:100%。
// height	常规验证码的高,支持百分比形式设置，如：height:10%。
// fontSize	常规验证码中的字母&数字的字体大小，默认为30px。
// codeLength	常规验证码中显示的验证码个数，默认为6。
//
// 运算验证码compute
// 参数	说明
//
// type	验证码type为compute或者2
// figure	运算验证码的位数,默认是100以内的数字，即两位数。如果是要设置三位数，则设置figure:1000。
// arith	算法选择，支持加、减、乘。设置为1至3分别代表加减乘，0为随机切换。。
// width	运算验证码的宽,支持百分比形式设置，如：width:100%。
// height	运算验证码的高,支持百分比形式设置，如：height:10%。
// fontSize	运算验证码中的数字的字体大小，默认为30px。
// showButton	是否显示确定按钮，默认为true
//
// 滑动验证码slide
// 参数	说明
//
// type	验证码type为slide或者3
// vOffset	滑动验证码的误差量，如：误差量为5px就能完成验证，设置vOffset:5。
// explain	滑动条内的提示，不设置默认是：向右滑动完成验证。
// barSize	其中包含了width、height两个参数，分别代表滑动条的宽度和高度，支持百分比方式设置，如：{width:‘100%’,height:‘40px’}
// showButton	是否显示确定按钮，默认为true
//
// 拼图验证码puzzle
// 参数	说明
//
// type	验证码type为puzzle或者4
// mode	验证码的显示方式，弹出式pop，固定fixed，默认是：mode : ‘fixed’。
// vOffset	滑动验证码的误差量，默认单位是px。如：误差量为5px就能完成验证，设置vOffset:5。
// vSpace	验证码图片和移动条容器的间隔，默认单位是px。如：间隔为5px，设置vSpace:5。
// explain	滑动条内的提示，不设置默认是：‘向右滑动完成验证’。
// imgUrl	背景图片的地址，不设置默认是：‘images/’。
// imgName	验证码背景图的数组集合，默认从images目录中进行读取，如 [‘1.jpg’, ‘2.jpg’]。
// imgSize	其中包含了width、height两个参数，分别代表图片的宽度和高度，支持百分比方式设置 如:{width:‘100%’,height:‘200px’}。
// blockSize	其中包含了width、height两个参数，分别代表拼图块的宽度和高度，如:{width:‘40px’,height:‘40px’}。。
// barSize	其中包含了width、height两个参数，分别代表滑动条的宽度和高度，支持百分比方式设置，如:{width:‘100%’,height:‘40px’}
// showButton	是否显示确定按钮，默认为true
//
// 选字验证码pick
// 参数	说明
//
//   type	验证码type为pick或者5
//   mode	验证码的显示方式，弹出式pop，固定fixed，默认是：mode : ‘fixed’。
//   defaultNum	验证码中出现的文字数量，如要默认4个字
//   checkNum	验证码中要求比对的文字数量，如要按序比对2个字
//   vSpace	验证码图片和移动条容器的间隔，默认单位是px。
//   imgUrl	背景图片的地址，不设置默认是：‘images/’。
//   imgName	验证码背景图的数组集合，默认从images目录中进行读取，如 [‘1.jpg’, ‘2.jpg’]。
//   imgSize	其中包含了width、height两个参数，分别代表图片的宽度和高度，支持百分比方式设置 如:{width:‘100%’,height:‘200px’}。
//   barSize	其中包含了width、height两个参数，分别代表滑动条的宽度和高度，支持百分比方式设置，如:{width:‘100%’,height:‘40px’}
//   showButton	是否显示确定按钮，默认为true
